import { connect } from 'react-redux';
import { AppState } from '../../../redux/modules/store';
import SearchResultTable from '../../../component/organisms/SearchResultTable';


const mapStateToProps = (appState: AppState) => {

  return {
    searchResult: appState.searchResult,
    loadingStatus: appState.loadingStatus.searchResult
  };
};

export default connect(mapStateToProps)(SearchResultTable);
